import { GLOBAL_START_EPOCH } from "./constants.mjs";
export const SHARED = globalThis.__supersig_state_shared__ ??= {
    globalEpoch: GLOBAL_START_EPOCH + 1,
    globalIsReacting: false,
    currentTransaction: null,
    captureStack: null,
    ATOM_BRAND: Symbol.for("__@supersig/state/atom__"),
    COMPUTED_BRAND: Symbol.for("__@supersig/state/computed__")
};
